import { Box, Divider, Flex, Heading, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Section, SectionHeading, Reveal } from '../components/Section';
import { CtaBanner } from '../components/CtaBanner';
import { Disclaimer } from '../components/Disclaimer';
import { company, images, principles } from '../data/site';
export function About() {
  return <>
      <Seo title="About Futuramy Investment LLC" description="Futuramy Investment LLC is a privately held company based in Plantation, Florida, focused on identifying opportunities, supporting strategic initiatives and developing long-term business value." path="/about" data-id="element-152" data-mp="3292gxxi60j5s" />
      <PageHeader eyebrow="About" title="About Futuramy Investment LLC" subtitle="Futuramy Investment LLC is a privately held company based in Plantation, Florida. Our focus is on identifying opportunities, supporting strategic initiatives and developing long-term business value." data-id="element-153" data-mp="2xbasjdgqbf6c" />

      <Section data-id="element-154" data-mp="1ujmpiggbwjff">
        <Flex direction={{
        base: 'column',
        lg: 'row'
      }} gap={{
        base: 12,
        lg: 20
      }} data-id="element-155" data-mp="1piyr39prt0b6">
          <Box flex="1.1" data-id="element-156" data-mp="23igjdz29yvpa">
            <SectionHeading eyebrow="Our perspective" title="Our Perspective" intro="We believe sustainable business growth begins with thoughtful decision-making, clear objectives and strong professional relationships." maxW="560px" data-id="element-157" data-mp="23iqbbs6vrcxm" />
            <Stack spacing={0} borderTop="1px solid" borderColor="navy.100" data-id="element-158" data-mp="28icmlw35ej3s">
              {principles.map((principle, index) => <Reveal key={principle.title} delay={index * 0.08} data-id="element-159" data-mp="2m86d0iuaxbfm" data-mpi={index}>
                  <Box py={7} borderBottom="1px solid" borderColor="navy.100" data-id="element-160" data-mp="2i8fetu2g3t12">
                    <Heading as="h3" fontSize="lg" mb={2} data-id="element-161" data-mp="2w6m4wo15koq6">
                      {principle.title}
                    </Heading>
                    <Text fontSize="sm" color="navy.500" lineHeight={1.8} maxW="520px" data-id="element-162" data-mp="2r9dkshwg2ama">
                      {principle.description}
                    </Text>
                  </Box>
                </Reveal>)}
            </Stack>
          </Box>

          <Box flex="1" data-id="element-163" data-mp="1xvkx8n04kc9g">
            <Stack spacing={8} data-id="element-164" data-mp="1xv2vjaup15u5">
              <Image src={images.about} alt="Abstract layered planes in white, grey and navy representing structure and stability" w="100%" h={{
              base: '220px',
              md: '300px'
            }} objectFit="cover" border="1px solid" borderColor="navy.100" loading="lazy" data-id="element-165" data-mp="1xu01wv5zkpaj" />
              <Box border="1px solid" borderColor="navy.100" bg="navy.50" p={{
              base: 7,
              md: 8
            }} data-id="element-166" data-mp="2gmc2bcd2xgi1">
                <Text fontSize="xs" fontWeight={600} letterSpacing="0.16em" textTransform="uppercase" color="accent.600" mb={6} data-id="element-167" data-mp="2lkdmy1q5lnvm">
                  Company Information
                </Text>
                <SimpleGrid columns={1} spacing={5} data-id="element-168" data-mp="jpg42lu6qetk">
                  <InfoRow label="Legal Name" value={company.legalName} data-id="element-169" data-mp="ewdc2i523dfh" />
                  <Divider borderColor="navy.100" data-id="element-170" data-mp="9xaefireo9hj" />
                  <InfoRow label="Business Name" value={company.businessName} data-id="element-171" data-mp="9y3anpsqnglf" />
                  <Divider borderColor="navy.100" data-id="element-172" data-mp="4zib7slb90y1" />
                  <InfoRow label="Location" value={company.city} data-id="element-173" data-mp="12m7kmniceftx" />
                </SimpleGrid>
              </Box>
            </Stack>
          </Box>
        </Flex>
      </Section>

      <Disclaimer data-id="element-174" data-mp="xnxreig6hpay" />
      <CtaBanner data-id="element-175" data-mp="so1jw989vfqn" />
    </>;
}
function InfoRow({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <Flex direction={{
    base: 'column',
    sm: 'row'
  }} justify="space-between" gap={1} data-id="element-176" data-mp="omq1anntfury">
      <Text fontSize="sm" color="navy.400" data-id="element-177" data-mp="3deafw0qsxlwb">
        {label}
      </Text>
      <Text fontSize="sm" fontWeight={500} color="navy.800" textAlign={{
      sm: 'right'
    }} data-id="element-178" data-mp="3dflku3vzgzp0">
        {value}
      </Text>
    </Flex>;
}